import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import ResourcesScreen from './component'
import Overlay from '../../Atoms/Overlay'
import CenteredSpinner from '../../Atoms/Spinner/CenteredSpinner'
import InlineError from '../../Atoms/InlineError'

import Splash from '../../Hocs/Splash'

import { fetchEventDetails } from '../../../redux/event'
import { fetchResources } from '../../../redux/resources'

import { reRegisterDevice } from '../../../redux/device'

import navigation from '../../../services/navigation'

class WaitingRoomContainer extends PureComponent {
  componentDidMount () {
    this.props.fetchEventDetails({
      eventId: this.props.eventId,
      participantId: this.props.participantId,
      environment: this.props.environment
    })
    this.props.fetchResources({
      eventId: this.props.eventId,
      participantId: this.props.participantId,
      environment: this.props.environment
    })
  }

  componentDidUpdate (prevProps) {
    if (prevProps.currentRound !== this.props.currentRound) {
      this.props.fetchResources({
        eventId: this.props.eventId,
        participantId: this.props.participantId,
        environment: this.props.environment
      })
    }
  }

  handleLogout = () => {
    navigation.doLogout()
  }

  render () {
    if (this.props.isLoading) {
      return <Overlay><CenteredSpinner /></Overlay>
    }

    if (this.props.error) {
      return <InlineError message={this.props.error.message} />
    }

    if (!this.props.isLoaded || !this.props.details) {
      return <Overlay><CenteredSpinner /></Overlay>
    }

    return (
      <Overlay>
        <ResourcesScreen
          participants={this.props.participants}
          isMaster={this.props.isMaster}
          registered={this.props.registered}
          onSettingsPress={this.props.onSettingsPress}
          onButtonPress={this.props.onButtonPress}
          onLogout={this.handleLogout}
          allowReconnect={this.props.allowReconnect}
          gameName={this.props.details.gameName}
          firstName={this.props.details.firstName}
          client={this.props.details.client}
          logo={this.props.details.eventLogo}
          eventDate={this.props.details.eventDate}
          eventClosed={this.props.details.eventClosed}
          resources={this.props.resources}
          gameStarted={this.props.gameStarted}
          gameState={this.props.gameState}
          buttonEnabled={this.props.buttonEnabled}
          deviceStatusChecked={this.props.registered ? this.props.deviceStatusChecked : !!this.props.deviceError}
          team={this.props.team}
          ceoTransferRequestId={this.props.ceoTransferRequestId}
        />
      </Overlay>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    deviceStatusChecked: state.device.deviceStatusChecked,
    registered: state.device.registered,
    deviceError: state.device.error,
    gameState: state.game.state,
    gameName: state.game.gameName,
    allowReconnect: state.device.hasSetupInfo && !state.device.registered,
    currentRound: state.game.currentRound,
    gameStarted: state.game.currentRound > 0,
    participantId: state.auth.participantId,
    eventId: state.auth.eventId,
    environment: state.auth.environment,
    isLoading: state.event.isLoading,
    isLoaded: state.event.isLoaded,
    error: state.event.error,
    details: state.event.details,
    resources: state.resources.resources,
    isMaster: state.device.isMaster,
    team: state.team,
    ceoTransferRequestId: state.participants.ceoTransferRequestId
  }
}

export default connect(mapStateToProps, {
  fetchEventDetails,
  fetchResources,
  reRegisterDevice
})(Splash(WaitingRoomContainer))
